import styled from 'styled-components';

export const CarouselContainer = styled.div`
  position: relative;
  aspect-ratio: ${({ $aspect }) => $aspect || '16/9'};
  width: 100%;
  overflow: hidden;
  background: ${({ $bg }) => $bg || 'transparent'};
  border-radius: 12px;
`;

export const CarouselWrapper = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: ${({ $currentIndex }) => `translateX(-${$currentIndex * 100}%)`};
  height: 100%;
`;

export const CarouselSlide = styled.div`
  min-width: 100%;
  box-sizing: border-box;
  height: 100%;
  display: flex; /* centraliza conteúdo */
  align-items: center; /* vertical */
  justify-content: center; /* horizontal */
`;

export const CarouselImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${({ $fit }) => $fit || 'cover'};
  object-position: center center;
  display: block;
`;

export const NavigationButton = styled.button`
  position: absolute;
  background-color: transparent;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  cursor: pointer;
  color: #92b21f;

  ${({ $position }) => $position === 'left' && `left: 10px;`}
  ${({ $position }) => $position === 'right' && `right: 10px;`}

  &:hover {
    background-color: #fff;
    opacity: 0.5;
  }
`;

export const IndicatorsContainer = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  gap: 5px;
`;

export const Indicator = styled.div`
  width: 12px;
  height: 12px;
  border: 2px solid #92b21f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $active }) =>
    $active &&
    `
      &::before {
        content: "";
        width: 6px;
        height: 6px;
        background-color: #92B21F;
        border-radius: 50%;
      }
    `}
`;
